/**
 * Base publique du monolithe Agenda (images via Glide /assets/…).
 */
export function getAgendaPublicBaseUrl() {
  const raw = process.env.REACT_APP_AGENDA_PUBLIC_URL || 'https://agenda.koikispass.com';
  return raw.replace(/\/+$/, '');
}

/**
 * Transforme un chemin média Agenda en URL Glide.
 */
export function resolveAgendaMediaUrl(path) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  const trimmed = path.trim();
  if (!trimmed) {
    return null;
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  let decoded = trimmed;
  try {
    decoded = decodeURIComponent(trimmed);
  } catch {
    // chemin déjà décodé
  }

  const normalized = decoded.replace(/^\/+/, '');
  return `${getAgendaPublicBaseUrl()}/assets/${normalized}`;
}
